<footer class="bg-white text-center text-dark p-1">
    <div class="col-md-12 text-center fw-bold">
      <a class="text-dark text-decoration-none" [routerLink]="'/member-portal/dashboard'">
        <img loading="lazy" [src]="environment.assetsURL + brandResources!.pathLogoBlack" class="img-fluid footer-logo" />
      </a>
      <small class="px-2 p-0"><i class="far fa-copyright"></i> {{ currentYear }}</small>
      <div class="my-3">
        <small>
          <small class="text-dark">
            <a class="text-decoration-none text-dark mx-2" routerLink="/contact" target="_blank" id="link-contact-us">Contact Us</a> |
            <a class="text-decoration-none text-dark mx-2" routerLink="/privacy" target="_blank" id="link-privacy-policy">Privacy Policy</a> |
            <br class="d-inline d-sm-none">
            <a class="text-decoration-none text-dark mx-2" routerLink="/terms" target="_blank" id="link-terms-and-conditions">Terms of Service</a>
          </small>
        </small>
      </div>
    </div>
</footer>